import { GlobalToken, theme } from 'antd';
import { AppToken } from '../context/AppContext/themes';

export default function useThemeToken(): GlobalToken & AppToken {
  const { token } = theme.useToken();
  return token as GlobalToken & AppToken;
}
